(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["jonelia-blitz-context"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('jonelia-blitz-context')){
 let cachedRequest;
 customElements.define('jonelia-blitz-context',class extends HTMLElement{
  connectedCallback(){
   this.form=this.closest('form');
   this.update=()=>requestAnimationFrame(()=>this.refresh());
   this.form?.addEventListener('change',this.update);
   document.addEventListener('variant:changed',this.update);
   this.refresh();
   this.timer=setInterval(()=>this.refresh(),30000);
  }
  disconnectedCallback(){clearInterval(this.timer);this.form?.removeEventListener('change',this.update);document.removeEventListener('variant:changed',this.update);}
  async refresh(){
   try{
    if(!cachedRequest)cachedRequest=(async()=>{var response=await fetch(this.dataset.source,{credentials:'same-origin'});if(response.ok){var sections=await response.json(),html=Object.values(sections).filter(Boolean).join('');if(html.trim())return new DOMParser().parseFromString(html,'text/html');}response=await fetch(this.dataset.fallback,{credentials:'same-origin'});if(!response.ok)throw Error('section');return new DOMParser().parseFromString(await response.text(),'text/html');})();
    const doc=await cachedRequest,now=Date.now()/1000;
    const slot=Array.from(doc.querySelectorAll('[data-blitz-slot]')).find(s=>now>=Number(s.dataset.start)&&now<Number(s.dataset.end)&&Number(s.dataset.used)<30);
    if(!this.isConnected)return;
    const cart=this.dataset.cartContext==='true';
    const variant=this.form?.elements.namedItem('id')?.value||this.dataset.variant;
    const matches=slot&&(cart?this.dataset.cartVariants.includes('|'+slot.dataset.variant+'|'):this.dataset.product===slot.dataset.product&&String(variant)===slot.dataset.variant);
    this.hidden=!matches;if(!matches)return;
    this.querySelector('[data-context-price]').textContent=slot.dataset.money;
    const link=this.querySelector('[data-context-activate]');
    const href=new URL(slot.dataset.discount,location.origin);
    if(!cart)href.searchParams.set('redirect',location.pathname+'?variant='+slot.dataset.variant);
    link.href=href.pathname+href.search;
    const applied=cart&&this.dataset.applied.toUpperCase().includes('|'+slot.dataset.code.toUpperCase()+'|');
    link.hidden=applied;this.querySelector('[data-context-active]').hidden=!applied;
   }catch(error){this.hidden=true;}
  }
 });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["jonelia-delivery-trust"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('jonelia-delivery-status')) {
  customElements.define('jonelia-delivery-status', class extends HTMLElement {
    connectedCallback() {
      this.form = this.closest('form');
      this.updateStatus = event => {
        if (!this.form?.contains(event.target)) return;
        const variant = event.detail?.variant;
        const selectedId = this.form.elements.namedItem('id')?.value;
        if (variant && String(variant.id) !== String(selectedId)) return;
        const status = this.querySelector('[data-jon-service-status]');
        const dot = this.querySelector('.jon-service-v3__dot');
        const stocked = variant?.inventory_management && variant.inventory_quantity > 0;
        if (status) status.textContent = !variant?.available ? this.dataset.unavailable : stocked ? this.dataset.inStock : this.dataset.available;
        if (dot) dot.hidden = !variant?.available;
      };
      document.addEventListener('variant:changed', this.updateStatus);
    }
    disconnectedCallback() {
      document.removeEventListener('variant:changed', this.updateStatus);
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["jonelia-portion-price"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('jonelia-portion-price')) {
  customElements.define('jonelia-portion-price', class extends HTMLElement {
    connectedCallback() {
      this.form = this.closest('form');
      this.sync = () => {
        const variantId = this.form?.elements.namedItem('id')?.value;
        if (!variantId) {
          this.hidden = true;
          return;
        }
        let matched = false;
        this.querySelectorAll('[data-portion-variant]').forEach(row => {
          const selected = row.dataset.portionVariant === String(variantId);
          row.hidden = !selected;
          if (selected) matched = true;
        });
        this.hidden = !matched;
      };
      this.schedule = () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(this.sync);
      };
      this.form?.addEventListener('change', this.schedule);
      document.addEventListener('variant:changed', this.schedule);
      this.schedule();
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      this.form?.removeEventListener('change', this.schedule);
      document.removeEventListener('variant:changed', this.schedule);
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["jonelia-rebrand-popup"] && !Shopify.designMode) return;
  try {
    (function () {
    var storageKey = 'jonelia_rebrand_seen_v1';

    function init(dialog) {
      if (!dialog || dialog.dataset.jonRebrandReady === 'true') return;
      dialog.dataset.jonRebrandReady = 'true';

      var forcePreview = window.location.search.indexOf('jonelia_rebrand=1') !== -1;
      var designMode = Boolean(window.Shopify && window.Shopify.designMode);
      var seen = false;

      try {
        seen = window.localStorage.getItem(storageKey) === 'true';
      } catch (error) {
        seen = false;
      }

      if (seen && !forcePreview && !designMode) return;

      function rememberAndClose() {
        if (!designMode) {
          try {
            window.localStorage.setItem(storageKey, 'true');
          } catch (error) {
          }
        }

        if (dialog.open) dialog.close();
      }

      dialog.querySelectorAll('[data-jon-rebrand-close]').forEach(function (button) {
        button.addEventListener('click', rememberAndClose);
      });

      dialog.addEventListener('cancel', function (event) {
        event.preventDefault();
        rememberAndClose();
      });

      dialog.addEventListener('click', function (event) {
        if (event.target === dialog) rememberAndClose();
      });

      window.setTimeout(function () {
        if (!dialog.open && typeof dialog.showModal === 'function') dialog.showModal();
      }, designMode ? 100 : 800);
    }

    document.querySelectorAll('[data-jon-rebrand-dialog]').forEach(init);
    document.addEventListener('shopify:section:load', function (event) {
      event.target.querySelectorAll('[data-jon-rebrand-dialog]').forEach(init);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["jonelia-refresh"] && !Shopify.designMode) return;
  try {
    (() => {
  'use strict';
  function init(scope = document) {
    scope.querySelectorAll('[data-jon-range]:not([data-ready])').forEach(root => {
      root.dataset.ready = 'true';
      const form = root.querySelector('form');
      const result = root.querySelector('output');
      const input = name => form.elements.namedItem(name);
      const format = n => new Intl.NumberFormat(root.dataset.locale, { maximumFractionDigits: 1 }).format(n);
      form.addEventListener('submit', event => {
        event.preventDefault();
        const quantity = input('pack').valueAsNumber;
        const daily = input('daily').valueAsNumber;
        const price = input('price').valueAsNumber;
        const horizon = Number(input('horizon').value);
        if (![quantity, daily, price, horizon].every(Number.isFinite) || quantity <= 0 || daily <= 0 || price < 0 || horizon <= 0) {
          result.textContent = root.dataset.invalid;
          return;
        }
        const days = quantity / daily;
        const money = new Intl.NumberFormat(root.dataset.locale, { style: 'currency', currency: root.dataset.currency });
        const values = { days: format(days), cost: money.format(price / days), packs: String(Math.ceil(horizon * daily / quantity)), horizon: format(horizon) };
        result.textContent = root.dataset.result.replace(/\{(days|cost|packs|horizon)\}/g, (_, key) => values[key]);
      });
      form.addEventListener('input', () => { result.textContent = ''; });
    });
    scope.querySelectorAll('[data-jon-rebrand]:not([data-ready])').forEach(root => {
      root.dataset.ready = 'true';
      const dialog = root.querySelector('dialog');
      const button = root.querySelector('[data-jon-rebrand-open]');
      if (!dialog || typeof dialog.showModal !== 'function') return;
      let previous;
      const remember = () => { try { sessionStorage.setItem('jonelia-rebrand-seen-v1', '1'); } catch (_) {} };
      const open = () => {
        if (dialog.open) return;
        previous = document.activeElement;
        dialog.showModal();
        remember();
      };
      button.addEventListener('click', open);
      dialog.querySelectorAll('[data-jon-rebrand-close]').forEach(close => close.addEventListener('click', () => dialog.close()));
      dialog.addEventListener('close', () => { remember(); if (previous instanceof HTMLElement) previous.focus({ preventScroll: true }); });
      dialog.addEventListener('click', event => { if (event.target === dialog) { const rect = dialog.getBoundingClientRect(); if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close(); } });
      let seen = false;
      try { seen = sessionStorage.getItem('jonelia-rebrand-seen-v1') === '1'; } catch (_) { seen = true; }
      if (root.dataset.auto === 'true' && !seen && !window.Shopify?.designMode) {
        setTimeout(() => {
          if (!root.isConnected || document.visibilityState !== 'visible' || document.querySelector('dialog[open],.jon-nelia.is-open')) return;
          if (document.activeElement?.matches('input,textarea,select')) return;
          const consent = document.querySelector('#shopify-pc__banner');
          if (consent && consent.getBoundingClientRect().height > 0) return;
          open();
        }, 25000);
      }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["jonelia-weekly-workbook"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('jonelia-weekly-workbook')) {
  customElements.define('jonelia-weekly-workbook', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.trackChoice = this.querySelector('[data-track-choice]');
      this.timeChoice = this.querySelector('[data-time-choice]');
      this.querySelectorAll('[data-controls]').forEach(el => { el.hidden = false; });
      this.querySelectorAll('.jon-workbook__day').forEach((day, index) => { day.open = index % 7 === 0; });
      this.trackChoice.addEventListener('change', () => this.updateView());
      this.timeChoice.addEventListener('change', () => this.updateView());
      this.querySelectorAll('[data-done]').forEach(box => box.addEventListener('change', () => this.updateView()));
      this.querySelector('[data-reset]').addEventListener('click', () => {
        this.activeTrack().querySelectorAll('[data-done]').forEach(box => { box.checked = false; });
        this.updateView();
      });
      this.querySelector('[data-export]').addEventListener('click', () => this.exportPlan());
      this.updateView();
    }
    activeTrack() {
      return Array.from(this.querySelectorAll('[data-track]')).find(el => el.dataset.track === this.trackChoice.value) || this.querySelector('[data-track]');
    }
    updateView() {
      const track = this.activeTrack();
      this.querySelectorAll('[data-track]').forEach(el => { el.hidden = el !== track; });
      this.querySelectorAll('[data-extra]').forEach(el => { el.hidden = this.timeChoice.value !== 'long'; });
      const done = track.querySelectorAll('[data-done]:checked').length;
      this.querySelector('[data-progress-text]').textContent = this.dataset.progressLabel.replace('__COUNT__', String(done));
      this.querySelector('progress').value = done;
    }
    planText() {
      const track = this.activeTrack();
      const lines = [this.dataset.exportTitle, track.querySelector('h2').textContent.trim(), this.timeChoice.selectedOptions[0].textContent.trim(), ''];
      track.querySelectorAll('.jon-workbook__day').forEach((day, index) => {
        lines.push((day.querySelector('[data-done]').checked ? '[x] ' : '[ ] ') + (index + 1) + '. ' + day.querySelector('h3').textContent.trim());
        lines.push(day.querySelector('[data-core]').textContent.trim());
        if (this.timeChoice.value === 'long') lines.push(day.querySelector('[data-extra]').textContent.trim());
        lines.push('');
      });
      lines.push(this.querySelector('.jon-workbook__notice')?.textContent?.trim() || this.querySelector('.jon-workbook__note').textContent.trim());
      return lines.join('\n');
    }
    exportPlan() {
      const blob = new Blob(['\uFEFF', this.planText()], { type: 'text/plain;charset=utf-8' });
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = 'Jonelia-Wochenbegleiter.txt';
      link.click();
      setTimeout(() => URL.revokeObjectURL(url), 1000);
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
